import Timer from 'otp-timer';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import OtpInput from 'react-otp-input';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { AuthContext } from '../../context/AuthContextProvider';
import nopreview from '../../assets/images/others/no-preview.png';

const Clients = () => {
  return (
    <>
      <Helmet>
        <title>Spandan  - Clients</title>
      </Helmet>

      <div className="main-wrappers" >


        <div className="page-wrapper">
          <div className="content">
            <div >
              <h4><strong>Clients</strong></h4>



            </div>
          </div>
        </div>
      </div>

    </>
  );
}




export default Clients;
